import React from 'react';

import { IconContainer } from './styles';

interface IIconProps {
  color?: string;
  icon: string;
  width?: number;
  height?: number;
}

const Icon: React.FC<IIconProps> = ({ color, icon, height, width }) => (
  <IconContainer color={color} icon={icon} height={height} width={width} />
);

export default Icon;
